import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { clientService } from '@/services/client-service';
import type { AgentDownloads } from '@/types/core/client';
import type { UUID } from '@/utils/uuid';

import { clientQueryKeys } from './query-keys';

export function useListAgentDownloads(
  tenantId: UUID | undefined
): UseQueryResult<AgentDownloads, Error> {
  return useQuery<AgentDownloads, Error>({
    queryKey: clientQueryKeys.downloads(tenantId),
    queryFn: () => clientService.listAgentDownloads(tenantId!),
    enabled: !!tenantId,
    staleTime: 5 * 60 * 1000,
  });
}
